import { render, staticRenderFns } from "./ReviewView.vue?vue&type=template&id=6fd15e9e"
import script from "./ReviewView.vue?vue&type=script&lang=js"
export * from "./ReviewView.vue?vue&type=script&lang=js"
import style0 from "./ReviewView.vue?vue&type=style&index=0&id=6fd15e9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports